module.exports = __webpack_public_path__ + "img/qr-code.fe75275d.png";